import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import { FlightEventClient, FlightEventReport, FlightEventReportDTO, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightEventClient = new FlightEventClient(apiBaseUrl);

function useUpdateFlightEvent() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<FlightEventReportDTO, ProblemDetails, FlightEventReport>({
    mutationKey: [queryKeys.FlightEvent.Update],
    mutationFn: (report: FlightEventReport) => flightEventClient.update(report),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useUpdateFlightEvent;
